import { audiences } from "./audiences";
import { serviceAreaPanels } from "./service-areas";



export type MegaItem = {
  to: string;
  params?: Record<string, string>;
  label: string;
  desc?: string;
};

export type MegaColumn = {
  eyebrow: string;
  items: MegaItem[];
};

export type MegaFeatured = {
  eyebrow: string;
  title: string;
  body: string;
  to: string;
  params?: Record<string, string>;
  cta: string;
};

export type MegaPanel = {
  kind: "mega";
  label: string;
  activeWhen: string[];
  columns: MegaColumn[];
  featured?: MegaFeatured;
};

export type SimpleLink = {
  kind: "link";
  to: string;
  label: string;
};

export type NavEntry = MegaPanel | SimpleLink;

export const nav: NavEntry[] = [
  ...serviceAreaPanels("sv"),

  {
    kind: "mega",
    label: "För vem",
    activeWhen: ["/for-vem", "/heritage", "/brollopsfilm"],
    columns: [
      {
        eyebrow: "Företag",
        items: audiences
          .map((a) => ({
            to: a.to,
            label: a.label,
            desc: a.intro,
          }))
          .concat([
            {
              to: "/heritage/kunskapsarv",
              label: "Kunskapsarv",
              desc: "Fånga seniora medarbetares kunskap innan de går i pension.",
            },
            {
              to: "/for-vem",
              label: "Alla spår",
              desc: "Hitta er matchning",
            },
          ]),
      },
      {
        eyebrow: "Privat",
        items: [
          {
            to: "/brollopsfilm",
            label: "Brudpar",
            desc: "Cinematisk bröllopsfilm — 1–3 bröllop per år.",
          },
          {
            to: "/heritage/livsberattelser",
            label: "Familjer",
            desc: "Livsberättelser på film, för kommande generationer.",
          },
          {
            to: "/heritage/kunskapsarv",
            label: "Yrkesveteraner",
            desc: "Fånga kunskapen innan den försvinner.",
          },
          {
            to: "/heritage",
            label: "Heritage",
            desc: "Allt om livsberättelser och kunskapsarv",
          },
        ],
      },
    ],
    featured: {
      eyebrow: "Hjälp att välja",
      title: "Företag eller privat?",
      body: "Två världar, samma hantverk. Se vilket spår som matchar er.",
      to: "/for-vem",
      cta: "Se översikt",
    },
  },

  { kind: "link", to: "/case", label: "Case" },

  {
    kind: "mega",
    label: "Resurser",
    activeWhen: ["/kunskap", "/faq", "/partners", "/guider"],
    columns: [
      {
        eyebrow: "Läs & lär",
        items: [
          { to: "/kunskap", label: "Blogg", desc: "Artiklar, perspektiv, hantverk" },
          { to: "/faq", label: "FAQ", desc: "Det vi får frågan om mest" },
        ],
      },
      {
        eyebrow: "Bevis",
        items: [
          { to: "/partners", label: "Partners", desc: "Byråer och plattformar vi jobbar med" },
        ],
      },
      {
        eyebrow: "Verktyg",
        items: [
          { to: "/guider", label: "Guider", desc: "Praktiska nedladdningar" },
        ],
      },
    ],

    featured: {
      eyebrow: "Ny för 2026",
      title: "Formatguide 2026",
      body: "En PDF som visar vilket format som funkar var — feed, story, YouTube, webinar.",
      to: "/guider",
      cta: "Ladda ner",
    },
  },
];
